import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import routes from '~pages'

const router = createRouter({
    // ...
    history: createWebHistory(),
    routes,
})

export default router;